
<template>
  <textarea rows="3" cols="3" class="form-control" @input="input" v-bind:placeholder="placeholder"
            v-on="listeners">{{value}}</textarea>
</template>

<script>
	export default {
    name: 'testcomponent',
		components: {
		},
    props: [
      'value',
      'text',
      'alt',
      'placeholder',
      'name',
      'id'
    ],
    methods: {
      input(event) {
        this.value = event.target.value;
        this.errors = this.validateinput(event.target.value);
        this.$emit('validationerror', this.errors);
        this.$emit('input', event.target.value);
      },
      validateinput(val) {
        var errors = [];
        return errors;
      }
    },
    created() {
      
    },
    mounted() {
     
    },
    computed: {
      listeners() {
        const { input, ...listeners } = this.$listeners;
        return listeners;
      },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-textarea.vue